import React from 'react';
import ServiceType from './ServiceType/ServiceType';
import LoadingScreen from '../../hoc/LoadingScreen';

import { Col, Form, Row, Alert } from 'react-bootstrap';

const serviceTypes = (props) => {

  let serviceTypes = (  
    <Alert variant="danger">
      <Alert.Heading>Viga!</Alert.Heading>
      <p>Selles asukohas ei leitud ühtegi aktiivset teenust!</p>
    </Alert>
  );

  if(props.serviceTypes.length>0){
    serviceTypes = props.serviceTypes.map((el) => {
      const isDesriptionActive = (props.serviceTypeDescriptionActive===el.id)
      return <ServiceType 
                key={el.id} id={el.id} name={el.name} price={el.price} isDescriptionActive={isDesriptionActive} description={el.description}
                onDescriptionShow={() => {props.descriptionToggleHandler(el.id, false)}}
                onDescriptionHide={() => {props.descriptionToggleHandler(el.id, true)}}
                isChecked={props.toggledItems.indexOf(el.id)!==-1? 1 : 0}
                changed={() => { props.changed(el.id) } } />
    });
  }

  let priceInfo = null;
  if(props.totalPrice!==null && isNaN(props.totalPrice)===false){
    priceInfo = (
      <Row>
        <Col xs={12} className="mb-3">
          Kokku: <strong>{props.totalPrice} &euro;</strong>
        </Col>
      </Row>
    );
  }

  return (
    <LoadingScreen isLoading={props.isLoading} text={props.loadingTxt}>
      <Row className="justify-content-md-center">
        <Col xs={12}>
          <Form>
            <Form.Group>
              <Form.Label><i className="fa fa-cog"></i> Vali teenused</Form.Label><br/>
              
                {serviceTypes}
            
            </Form.Group>
          </Form>
        </Col>
      </Row>
      {priceInfo}
    </LoadingScreen>
  );

}

export default serviceTypes;